<template>
    <div class="modal-full" v-if="publication">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>View Publication</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="publication-sidebar h-full">
                    <div class="mb-4 text-center">
                        <p class="text-lg font-light">Publication</p>
                    </div>

                    <div class="mb-3">
                        <label>Publication ID</label>
                        <p>{{ publication.id }}</p>
                    </div>
                </div>

                <div class="publication-body">
                    <form class="profile-form">
                        <div class="form-title">
                            <p class="text-lg font-light">Publication</p>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="publication.title">
                            <label>Title</label>
                        </div>

                        <div class="form-field">
                            <textarea v-model="publication.description"></textarea>
                            <label>Description</label>
                        </div>

                        <div class="form-field">
                            <input type="number" v-model="publication.readership">
                            <label>Readership</label>
                        </div>

                        <div class="form-field">
                            <input type="text" v-model="publication.readership_source">
                            <label>Readership Source</label>
                        </div>

                        <div class="form-field">
                            <label class="block text-gray-800 text-sm mb-2">Media Type</label>
                            <select v-model="publication.type"
                                    class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline">
                                <option value="0">Select a Media Type</option>
                                <option v-for="option in mediaTypes" v-bind:value="option">
                                    {{ option }}
                                </option>
                            </select>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="left text-left">
                    <div class="actions" v-click-away="hideActions">
                        <div class="actions-menu" v-show="actionsShown">

                            <button class="btn-danger muted" type="button" @click="handleDeletePublication">Delete
                            </button>
                            <button class="btn-primary muted" type="button" @click="handleViewIP">View IP</button>
                            <button v-if="allows('users')" class="btn-primary muted" type="button"
                                    @click="handleViewUsers">View Publication Users
                            </button>
                        </div>
                        <button class="btn-primary muted" type="button" :data-open="actionsShown"
                                @click="actionsShown = !actionsShown">
                            <ChevronUpIcon class="h-6 w-6 inline" />
                            Actions
                        </button>
                    </div>
                </div>
                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import Permissions from '../../../mixins/Permissions'
import {ChevronUpIcon} from "@heroicons/vue/24/solid"

export default {
    name: 'PublicationsView',
    mixins: [
        Permissions
    ],
    components: {
        ChevronUpIcon
    },
    data() {
        return {
            publication: null,
            actionsShown: false,
        }
    },
    mounted() {
        this.loadData()
        this.setMetaTitle('View Publication | JournoLink Control')
    },
    methods: {
        loadData() {
            axios.get(route('publications.show', this.$route.params.publicationId))
                .then(response => {
                    this.publication = response.data.publication
                    this.mediaTypes = response.data.mediaTypes
                    this.setMetaTitle('View Promotion | JournoLink Control')
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List Promotions | JournoLink Control')
            this.$root.goBack()
        },
        /**
         * Hide the actions box
         */
        hideActions() {
            this.actionsShown = false
        },
        /**
         * Handle a delete event for this request
         *
         * @return {void}
         */
        handleDeletePublication() {
            this.alert.fire({
                title: 'Are you sure?',
                text: 'Are you sure you wish to delete this individual publication?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, continue',
                confirmButtonColor: '#E3342F',
                cancelButtonText: 'No, go back'
            })
                .then((selected) => {
                    if (selected.value) {
                        axios.delete(route('publications.delete', this.$route.params.publicationId), {}).then(response => {
                            this.$bus.$emit('alert.success', 'Individual publication has been deleted')
                            this.closeView()
                        }).catch(e => {
                            this.$bus.$emit('alert.danger', 'Delete failed')
                        })
                    }
                })
        },
        /**
         *
         */
        saveForm() {
            axios.put(route('publications.update', this.$route.params.publicationId), this.publication)
                .then(response => {
                    this.publication = response.data.publication
                    this.$bus.$emit('alert.success', 'Publication has been updated')
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        handleViewUsers() {
            this.$root.persist.usersSearch = "publication:" + this.publication.id
            this.$router.push({name: 'users.list'})
        },
        handleViewIP() {
            this.$root.persist.ipSearch = "publication:" + this.publication.id
            this.$router.push({name: 'publications.ip.list'})
        }
    },
}
</script>

<style lang="less">
.publication-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.publication-body {
    flex: 1;
    padding: 15px;
}

.publication-activity {
    width: 250px;
    font-size: 0.9rem;
    padding: 15px;
}

.actions-menu {
    position: fixed;
    left: 0;
    bottom: 72px;
    padding: 15px;
    background: #dde0e2;

    > button {
        margin-bottom: 10px;
        display: block;
        width: 100%;
    }
}
</style>
